import { FormContainer } from '@eBeihilfe/einreichung-shared/model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const containersListActions = createActionGroup({
  source: 'Containers List',
  events: {
    'Load': emptyProps(),
    'Load success': props<{ containersList: FormContainer[] }>(),
    'Load failed': props<{ error: Error }>(),
    'Clear store': emptyProps(),
  },
});
